module.exports = __webpack_public_path__ + "static/media/BusinessSavings.11b8d58a.svg";